module.exports = __webpack_public_path__ + "assets/img/al10.107b721d.jpg";